const fields = [
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'license_plate',
    filter: true,
    width: 20,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicle_type',
    filter: false,
    width: 30,
  },
  {
    key: 'countRefueling',
    label: 'report.fields.refuelingCount',
    header: 'count_refueling',
    filter: false,
    width: 10,
  },
  {
    key: 'countFuelLoss',
    label: 'report.fields.fuelLossCount',
    header: 'count_fuel_loss',
    filter: false,
    width: 10,
  },
  {
    key: 'sensorType',
    label: 'report.fields.sensorType',
    header: 'sensor_type',
    filter: false,
    width: 20,
  },
  {
    key: 'totalFuel',
    label: 'report.fields.fuelUsage',
    header: 'total_fuel',
    filter: false,
    width: 20,
  },
  {
    key: 'totalDistance',
    label: 'report.fields.distance',
    header: 'total_distance',
    filter: false,
    width: 20,
  },
  {
    key: 'totalHours',
    label: 'report.fields.travelDuration',
    header: 'total_hours',
    filter: false,
    width: 20,
  },
  {
    key: 'idleDuration',
    label: 'report.fields.idleDuration',
    header: 'idle_duration',
    filter: false,
    width: 20,
  },
  {
    key: 'actualEfficiency',
    label: 'report.fields.actualEfficiency',
    header: 'actual_efficiency',
    filter: false,
    width: 20,
  },
  {
    key: 'standardEfficiency',
    label: 'report.fields.stdEfficiency',
    header: 'standard_efficiency',
    filter: false,
    width: 20,
  },
  {
    key: 'price',
    label: 'report.fields.cost',
    header: 'price',
    filter: false,
    width: 20,
  },
]
export default fields
